import { Routes } from "~/routes";

// // // //

interface PlanFeature {
    text: string;
    badge?: string;
    badgeLink?: string;
    badgeDownloadUrl?: string;
}

interface PlanMetadata {
    id: "FREE" | "PRO" | "ENTERPRISE" | "ACADEMIC";
    name: string;
    price: string;
    period: string;
    description: string;
    features: (string | PlanFeature)[];
    cta: string;
    popular: boolean;
}

export const FREE_PRICING_PLAN_METADATA: PlanMetadata = {
    id: "FREE",
    name: "Free",
    price: "$0",
    period: "/month",
    description:
        "The ultimate starter package—comprehensive market intelligence for tokenized real-world assets",
    features: [
        "Access the public RWA.xyz platform",
        "1 CSV download per day",
        "Basic tokenization analytics",
        "Community support",
    ],
    cta: "Get Started",
    popular: false,
};

export const PRO_PRICING_PLAN_METADATA_MONTHLY_50_EXPERIMENT: PlanMetadata = {
    id: "PRO",
    name: "Pro",
    price: "$49.99",
    period: "/month",
    description:
        "For professionals who need to deeply analyze tokenized products, platforms, and trends",
    features: [
        "Access to all metrics",
        "30 CSV downloads per month",
        "MCP access for AI agents",
        "Full asset reference data",
        "Fixed-income & APY data",
        {
            text: "Complimentary onboarding",
            badge: "Book a Call",
            badgeDownloadUrl:
                "https://scheduler.default.com/rwa-xyz/adamlawrence/20-minute",
        },
        "Advanced chart breakdowns and exports",
    ],
    cta: "Start 7-Day Free Trial",
    popular: true,
};

export const PRO_PRICING_PLAN_METADATA: PlanMetadata = {
    id: "PRO",
    name: "Pro",
    price: "$500",
    period: "/seat/month",
    description:
        "For professionals who need to deeply analyze tokenized products, platforms, and trends",
    features: [
        "Access to all metrics",
        "30 CSV downloads per month",
        "MCP access for AI agents",
        "Full asset reference data",
        "Fixed-income & APY data",
        {
            text: "Complimentary onboarding",
            badge: "Book a Call",
            badgeDownloadUrl:
                "https://scheduler.default.com/rwa-xyz/adamlawrence/20-minute",
        },
        "Advanced chart breakdowns and exports",
    ],
    cta: "Upgrade to Pro",
    popular: true,
};

export const ENTERPRISE_PRICING_PLAN_METADATA: PlanMetadata = {
    id: "ENTERPRISE",
    name: "Enterprise (includes API)",
    price: "Custom",
    period: "",
    description:
        "For teams building tokenization products, operationalizing workflows, and compliance",
    features: [
        "Unlimited CSV downloads for all metrics",
        {
            text: "Full API access",
            badge: "See Data Catalog ↗",
            badgeLink: Routes.catalog,
        },
        "Snowflake data share / bulk delivery",
        "Redistribution & commercial license rights",
        "Ad-hoc data requests and collection",
        "Dedicated technical and research support",
    ],
    cta: "Contact Sales",
    popular: false,
};

export const ACADEMIC_PRICING_PLAN_METADATA: PlanMetadata = {
    id: "ACADEMIC",
    name: "Academic",
    price: "$149.99",
    period: "/month",
    description:
        "For academic institutions and researchers to access tokenized real-world asset data",
    features: [
        "Unlimited CSV downloads for all metrics",
        {
            text: "Full API access",
            badge: "See Data Catalog ↗",
            badgeLink: Routes.catalog,
        },
        "Public citations required",
        "No technical support",
        "No redistribution or commercial license rights",
    ],
    cta: "Upgrade to Pro",
    popular: true,
};

export const PRICING_PLAN_METADATA: PlanMetadata[] = [
    FREE_PRICING_PLAN_METADATA,
    PRO_PRICING_PLAN_METADATA,
    ENTERPRISE_PRICING_PLAN_METADATA,
];

export const PRICING_PLAN_METADATA_ACADEMIC: PlanMetadata[] = [
    FREE_PRICING_PLAN_METADATA,
    ACADEMIC_PRICING_PLAN_METADATA,
    ENTERPRISE_PRICING_PLAN_METADATA,
];

export const PAYWALL_EXCLUDED_PAGES = [
    Routes.home,
    Routes.overview,
    Routes.login,
    Routes.register,
    Routes.authError,
    Routes.authVerify,
    Routes.citations,
    Routes.salesPage,
    // Routes.pricing,
    Routes.payment_success,
    Routes.settings,
    Routes.settingsProfile,
    Routes.settingsPlan,
    Routes.settingsOrganization,
    Routes.newAssetMonitor,
    Routes.assetScreener,
    Routes.blog,
    Routes.blogIndividual,
    Routes.search,
    Routes.privacyPolicy,
    Routes.about,
    Routes.termsOfUse,
];
